import { FORCE_ACTIONS } from '../actions';
import { ForceState } from '../state';

export const addForceReducer = (state: ForceState, { force }: ReturnType<typeof FORCE_ACTIONS.ADD_FORCE>) => {
    return {
        ...state,
        forces: [...state.forces, force]
    };
};
